// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pforeEntity from './entities/pfore.json';
import pforeMenu from '../pages/pfore/menu.json';
import pforeFullForm from '../pages/pfore/forms/full.json';
import pforeContextForm from '../pages/pfore/forms/context.json';
import pforeMiniForm from '../pages/pfore/forms/mini.json';
import pforeLookupForm from '../pages/pfore/forms/lookup.json';
import pforeTableView from '../pages/pfore/views/table.json';
import pforeStagesView from '../pages/pfore/views/stages.json';
import pforeCardsView from '../pages/pfore/views/cards.json';
import pforeInlineView from '../pages/pfore/views/inline.json';
import pforeBacklogView from '../pages/pfore/views/backlog.json';
import pforeSplitView from '../pages/pfore/views/split.json';
import pforeCalendarView from '../pages/pfore/views/calendar.json';
import pforeDashboardView from '../pages/pfore/views/dashboard.json';
import pforeTradarView from '../pages/pfore/views/tradar.json';

/** Тип запису «Сценарій» зі сторінками пакета: меню, форми та подання з pages/pfore/. */
export const pforeDefinition: IRecordTypeDefinition = {
  ...pforeEntity,
  views: assembleViewSet({
      table: pforeTableView,
      stages: pforeStagesView,
      cards: pforeCardsView,
      inline: pforeInlineView,
      backlog: pforeBacklogView,
      split: pforeSplitView,
      calendar: pforeCalendarView,
      dashboard: pforeDashboardView,
      tradar: pforeTradarView,
  }),
  form: pforeFullForm,
  forms: { full: pforeFullForm, context: pforeContextForm, mini: pforeMiniForm, lookup: pforeLookupForm },
  menu: pforeMenu,
} as IRecordTypeDefinition;
